import { SegmentedControl } from "@blueprintjs/core";
import { ChartMetric, CHART_METRICS, CHART_METRIC_LABELS } from "./chartMetric";

/**
 * Single-choice picker for the field a chart plots. Every option is laid
 * out at once, so switching cannot resize the control.
 */
export const ChartMetricSelect: React.FC<{
    value: ChartMetric;
    onChange: (metric: ChartMetric) => void;
    /** Defaults to every metric. Narrow it where one makes no sense. */
    options?: ReadonlyArray<ChartMetric>;
}> = ({ value, onChange, options = CHART_METRICS }) => (
    <SegmentedControl
        small
        options={options.map((metric) => ({
            label: CHART_METRIC_LABELS[metric],
            value: metric
        }))}
        value={value}
        onValueChange={(next) => onChange(next as ChartMetric)}
    />
);
